import Upload from "rc-upload";
import { AiOutlineUpload } from "react-icons/ai";
import { IMAGE_FILE_TYPES, MAX_SIZE_MB } from "shared/constant/common.constant";
import useAlertModalAtom from "shared/model/useAlertModalAtom";
import styled from "styled-components";

const UploadImage = ({ imgUrl, loading, uploadImage }) => {
  const [, setAlert] = useAlertModalAtom();

  const onChangeImage = async ({ file }) => {
    if (file.status === "error") {
      setAlert("upload failed");
    }
    if (file.status === "uploading") {
      console.log("uploading");
    }
  };

  const handleUploadImage = async (data) => {
    const { file } = data;
    const isAllowedType = IMAGE_FILE_TYPES.includes(file.type);

    if (!isAllowedType) {
      setAlert("The uploaded file format is not supported.");
      return;
    }

    const isLtMaxSize = file.size / 1024 / 1024 < MAX_SIZE_MB;
    if (!isLtMaxSize) {
      setAlert("The uploaded file size is too large.");
      return;
    }

    try {
      await uploadImage(file);
    } catch (error) {
      console.log("🚀~error :", error);
    }
  };

  const props = {
    type: "drag",
    accept: IMAGE_FILE_TYPES.join(","),
    onChange: onChangeImage,
    showUploadList: false,
    multiple: false,

    customRequest: handleUploadImage,
    beforeUpload() {
      return true;
    },
  };
  return (
    <div style={{ position: "relative" }}>
      <StyledUpload {...props}>
        {imgUrl ? (
          <img src={imgUrl} alt="uploaded" />
        ) : (
          <AiOutlineUpload size={30} />
        )}
      </StyledUpload>
    </div>
  );
};

export default UploadImage;

const StyledUpload = styled(Upload)`
  background-color: #eef0f2;
  width: 220px;
  height: 220px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background-color: #e0e2e4;
  }
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    overflow: hidden;
    border-radius: 6px;
  }
`;

const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 230px;
  height: 230px;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  .loading-icon {
    animation: spin 1s linear infinite;
    color: #000;
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const imgFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });
};
